import { SET_EDIT_MODE } from '../actions';

export const setEditModeAction = (status: boolean) =>
  SET_EDIT_MODE({ payload: status });
